function cloudflareSrcAt(src: string, width: number) {
  const newUrl = new URL(src);

  newUrl.pathname = `/cdn-cgi/image/width=${width},format=auto${newUrl.pathname}`;

  return `${newUrl}`;
}

function imgixSrcAt(src: string, width: number) {
  const newUrl = new URL(src);

  if (newUrl.pathname.endsWith(".gif") == false) {
    newUrl.searchParams.set("w", `${width}`);
  }

  return `${newUrl}`;
}

export function srcAt(src: string, width: number) {
  const newUrl = new URL(src);

  switch (newUrl.hostname) {
    case "static-dev.smartparks.dev":
    case "static.smartparks.dev":
    case "static.smartparks.co":
      return cloudflareSrcAt(src, width);
    default:
      return imgixSrcAt(src, width);
  }
}

export function srcSetAt(src: string, width: number, density: number) {
  return `${srcAt(src, width * density)} ${density}x`;
}

const dpi = [1, 2, 3];

export function sourcesAt(src: string, width: number) {
  return dpi.map((px) => srcSetAt(src, width, px)).join(", ");
}
